// src/App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";

import Home from "./pages/Home";
import MyProfile from "./pages/MyProfile";
import BookDetail from "./pages/BookDetail";
import EntryDetail from "./pages/EntryDetail";
import ManageRoles from "./pages/ManageRoles";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import InviteRedirectHandler from "./components/InviteRedirectHandler";
import Requests from "./pages/Requests";

import ApkDetectionWrapper from "./ApkDetectionWrapper";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const ProtectedRoute = ({ children }) => {
  const { token, loading } = useAuth();

  if (loading) {
    return <div className="centered">Loading...</div>;
  }

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <ApkDetectionWrapper>
      <div className="app-root">
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <MyProfile />
              </ProtectedRoute>
            }
          />

          <Route
            path="/books/:bookId"
            element={
              <ProtectedRoute>
                <BookDetail />
              </ProtectedRoute>
            }
          />

          <Route
            path="/books/:bookId/roles"
            element={
              <ProtectedRoute>
                <ManageRoles />
              </ProtectedRoute>
            }
          />

          <Route
            path="/entries/:entryId"
            element={
              <ProtectedRoute>
                <EntryDetail />
              </ProtectedRoute>
            }
          />

          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          <Route
            path="/books/invite/:inviteId"
            element={<InviteRedirectHandler />}
          />

          <Route path="/requests" element={<Requests />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </ApkDetectionWrapper>
  );
}

export default App;
